import { render } from "./ApplicationView.vue?vue&type=template&id=e54809a4&scoped=true&ts=true"
import script from "./ApplicationView.vue?vue&type=script&lang=ts"
export * from "./ApplicationView.vue?vue&type=script&lang=ts"

import "./ApplicationView.vue?vue&type=style&index=0&id=e54809a4&scoped=true&lang=css"

import exportComponent from "D:\\Development\\Casa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e54809a4"]])

export default __exports__